// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="altAddressDialogHeader">Confirm Property IDs</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="altAddressDialogBody1">This is the address associated with the Property IDs entered.</p>
            <div class="u-pB5" [innerHTML]="data.propertyAddress" tid="altAddressDialogAddress"></div>
            <p tid="altAddressDialogBody2">Please select OK, to accept the address or cancel to re-enter the Property IDs.</p>
            <p tid="altAddressDialogBody3">For questions regarding the address found, please contact your management company.</p>
            <div class="u-mB9"><a (click)="openUrl(data.contactUrl)" tid="contactLink">Contact {{data.pmcName}}</a></div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" tid="altAddressDialogCancel" (click)="closeThisDialog('O')">Cancel</button>
            <button class="Button Button--blue Button--minWidth130" tid="altAddressDialogOk" (click)="closeThisDialog('A')">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;